module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAhCAYAAAAswACjAAAA/klEQVRIie2WAQ7DIAgAwfQl3RP2hb6lj9pb9oU+of0KC4k4ZrRg65IlK4mpBeVExIhEBA2iB6N3WjgIKP2fhtQcukAeSO4o3yYTZEFqgCbQHsSKwA2qQSxAE6gE8QLcoBzSCnCBQs3QUmwWKOSKg4BdUOgIqIKGDk5NUMvddVguyJ9D5lgvpTYjInADgFXZV6Uvzhe7OydExIBRqUYyHgjJrscR0URvmUp67SDKHBvFhaRFid0biUSwKZ3075U5yX4dYY9ITpehs+P8xG2I+PhmJAy4cad3JMmxlp9KvJz5j4qP36ULBBGfAsornxPbBRKd8V4zTIT3334fAMALAYSOfQJl4U8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon5.png
// module id = 7p1c
// module chunks = 0